module.exports = __webpack_public_path__ + "img/Bard.2a56f177.png";